
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import ViewURL from "../../Modal/ViewURL";
import { useAuthState } from "../../../../../../../../../Helper/Context";
import { ComplaintTrackGetTableDataAPI } from "../../../../../../../../../Redux/EnchrochmentDashboardSlice/ReceivedComplaintsSocialMediaSlice/UploadedComplaintSlice";
import { Loading } from "../../../../../../../../../Helper/Loading";

const ComplaintTrackPopUp = (props) => {

    const { handleComplaintTrack, heading, gridData, DashSelect, Language } = props

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails

    const [IsClear, setIsClear] = useState(false)
    const [IsSearch, setIsSearch] = useState(false)
    const [CompleteTrackData, setCompleteTrackData] = useState([])

    const [ImagePopUpData, setImagePopUpData] = useState('')
    const [showImagePopup, setshowImagePopup] = useState(false)


    const { t } = useTranslation()

    const handleShowImage = (img) => {
        setshowImagePopup(true)
        setImagePopUpData(img)
    }

    useEffect(() => {
        const data = {
            T_ComplaintDetailsID: gridData.t_ComplaintDetailsID,
            Language: Language.Label,
            M_UserID: UserID,
            Top: "99999",
            token: token,
            setCompleteTrackData: setCompleteTrackData,
        }
        dispatch(ComplaintTrackGetTableDataAPI({ data }))
    }, [DashSelect, IsClear, IsSearch, Language.Label])

    const { isLoading, tableData } = useSelector(state => state.ComplaintTrackGetTableData)


    return (
        <>

            <div className="modal fade show" style={{ display: "flex", alignItems: 'center', backgroundColor: "#00000090" }}>
                <div className="modal-dialog modal-xl">
                    <div className="modal-content p-3">
                        <div className="modal-header pt-0">

                            <span className="card-title fw-bold fs-5" id="exampleModalLongTitle">
                                {t('EncroachmentDashboard.CreateByOfficerName')} -
                                <span className="text-danger px-2">{CompleteTrackData && CompleteTrackData.length > 0 ? CompleteTrackData[0]?.createBy_OfficerName : '-'} </span> -
                                <span className="text-primary px-2">{CompleteTrackData && CompleteTrackData.length > 0 ? moment(CompleteTrackData[0]?.createdDate).format('DD-MM-YYYY') : '-'} </span>
                            </span>
                            <button onClick={() => handleComplaintTrack()} type="button" className="close" style={{ marginLeft: "auto" }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        {isLoading && <Loading />}
                        <div className="modal-body">

                            <div className="row" >
                                <div className="col-12  " >
                                    <div className="table-responsive table-responsive-fix">
                                        <table className="table table-striped table-bordered">
                                            <thead className="header_position">
                                                <tr>
                                                    <th className="w-6 text-center">{t('EncroachmentDashboard.SrNo')}</th>
                                                    <th className="text-center">{t('EncroachmentDashboard.FromOfficerName')}</th>
                                                    <th className="text-center">{t('EncroachmentDashboard.FromStatus')}</th>
                                                    <th className="text-center">{t('EncroachmentDashboard.FromDate')}</th>
                                                    <th className="text-center">{t('EncroachmentDashboard.ToOfficerName')}</th>
                                                    <th className="text-center">{t('EncroachmentDashboard.ToStatus')}</th>
                                                    <th className="text-center">{t('EncroachmentDashboard.ToDate')}</th>
                                                    <th className="text-center">{t('EncroachmentDashboard.Remark')}</th>

                                                </tr>

                                            </thead>
                                            <tbody>

                                                {
                                                    CompleteTrackData && CompleteTrackData?.length > 0 ? CompleteTrackData?.map((i, j) => {
                                                        return (
                                                            <tr>
                                                                <td className="py-1" align="center">{i.rowNum}</td>

                                                                <td >{i.from_OfficerName ? i.from_OfficerName : '-'}</td>
                                                                <td >{i.fromStatusName ? i.fromStatusName : '-'}</td>
                                                                <td >{i.from_DateTime ? moment(i.from_DateTime).format("DD-MM-YYYY") : '-'}</td>
                                                                <td >{i.to_OfficerName ? i.to_OfficerName : '-'}</td>
                                                                <td >{i.toStatusName ? i.toStatusName : '-'}</td>
                                                                <td >{i.to_DateTime ? moment(i.to_DateTime).format("DD-MM-YYYY") : '-'}</td>
                                                                <td >{i.remarks ? i.remarks : '-'}</td>

                                                            </tr>
                                                        )
                                                    })
                                                        :
                                                        <tr>
                                                            <td colSpan={10}>No data found ...</td>
                                                        </tr>
                                                }


                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="row">
                                {/* <div className="col-12 pt-3">
                                    <button
                                        type='button'
                                        // onClick={() => confirmBtnCallBack(deleteRecord)}
                                        className="w-80 btn addbtn btn-success btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u m-2 px-4" data-ktwizard-type="action-next">
                                       
                                        {t('EncroachmentDashboard.Forward')}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleSiteVerificationDetails}
                                        className="w-80  btn addbtn btn-danger btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u m-2 px-4" data-ktwizard-type="action-next">
                                        <i class="fa-solid fa-xmark pe-1"></i> Cancel

                                    </button>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
                {
                    showImagePopup ?
                        <ViewURL
                            Heading={t('EncroachmentDashboard.View')}
                            setshowImagePopup={setshowImagePopup}
                            ImagePopUpData={ImagePopUpData}

                        />
                        : ''
                }
            </div>

        </>);
}

export default ComplaintTrackPopUp;